export enum Constants {
  ClientId = import.meta.env.VITE_AZURE_CLIENT_ID,
  Authority = import.meta.env.VITE_AZURE_AUTHORITY_URI,
  RedirectUri = import.meta.env.VITE_AZURE_REDIRECT_URI,
}

export const AUTH_SCOPES = ['openid', 'profile', 'offline_access', 'Files.ReadWrite'];
export const EXTENDED_AUTH_SCOPES = [...AUTH_SCOPES, 'Files.ReadWrite.All'];
